//angular
import { Component, Inject, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
//app
import { AppAnimations } from 'src/app/_shared/animations';
import {RestResponse, ShipperHqServicesModel, ShippingRatesModel} from 'src/app/_shared/models';
import { ShippingCustomFreeShippingStaticValues, VisibleState, responseCode } from 'src/app/app.data';
import { ShippingService } from 'src/app/_core/services/shipping.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
import { ShippingMethodComponent } from 'src/app/_shared/elements/shipping-method/shipping-method.component';
import { MetaService } from 'src/app/_core/services/meta.service';
import { KeyName } from 'src/app/app.keynames';
import { IntegrationService } from '../../../integrations/_services/api/integration.service';

@Component({
  animations: [AppAnimations],
  selector: 'app-customer-shippingmethod',
  templateUrl: './customer-shippingmethod.component.html'
})
export class DialogCustomerShippingMethodComponent implements OnInit, OnDestroy {
  collectionOfShippingMethod: Array<ShippingRatesModel> = [];
  collectionOfShipperHqServices: Array<ShipperHqServicesModel> = [];
  collectionIsEmpty: boolean = false;
  isFormReady: boolean = false;
  shippingError: boolean = false;
  shippingStaticValues = ShippingCustomFreeShippingStaticValues;
  showShippingAmount: boolean = false;
  private subs = new Unsubscriber();

  @Input() _visibleState = VisibleState;

  @ViewChild(ShippingMethodComponent) _shippingMethodComponent: ShippingMethodComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef: MatDialogRef<DialogCustomerShippingMethodComponent>,
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private _shipping: ShippingService,
    public _meta: MetaService,
    private integrationService: IntegrationService
  ) {

    this._iconRegistry.addSvgIcon('ico-close', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));

  }

  ngOnInit(): void {
    const hasCollection = this.data.collectionOfShippingServices || this.data.collectionOfShipperHqServices;
    if(hasCollection) {
      this.collectionOfShippingMethod = this.data.collectionOfShippingServices;
      this.collectionOfShipperHqServices = this.data.collectionOfShipperHqServices;
      this.showShippingAmount = false;
      this.isFormReady = true;
      this.shippingError = false;
      this.collectionIsEmpty = this.data.collectionOfShippingServices.length === 0 && this.data.collectionOfShipperHqServices.length === 0;
    } else {
      this.subs.addSub = this._shipping.calculateShipping(this.data.detailList, this.data.shippingAddress, this.data.companyCurrencyId).subscribe(
          (res:RestResponse)=> {
            const collectionOfShippingMethodFull = <Array<ShippingRatesModel>>res.data;
            if(collectionOfShippingMethodFull.length == 0) {
              this.isFormReady = true;
              this.shippingError = true;
            }
            else {

              const hasCustom = collectionOfShippingMethodFull.find( x => x.integrationName == this.shippingStaticValues.shippingCustomKey);

              if(hasCustom) {
                const hasFree = collectionOfShippingMethodFull.find( x => x.integrationName == this.shippingStaticValues.shippingFreeKey);

                if(!hasFree) {
                  collectionOfShippingMethodFull.unshift(
                    <ShippingRatesModel>{
                      amount: null,
                      companyIntegrationId: hasCustom.companyIntegrationId,
                      currency: hasCustom.currency,
                      integrationName: this.shippingStaticValues.shippingFreeKey,
                      serviceId: hasCustom.serviceId,
                      serviceName: 'Free Shipping',
                      carrierName: 'Free Shipping'

                  });
                }

                this.collectionOfShippingMethod = collectionOfShippingMethodFull.filter(x => x.integrationName != this.shippingStaticValues.shippingCustomKey);
                this.collectionOfShippingMethod.push(hasCustom);
              } else {
                this.collectionOfShippingMethod = collectionOfShippingMethodFull;
              }

              this.showShippingAmount = true;
              this.isFormReady = true;
              this.shippingError = false;

              this.collectionIsEmpty = this.collectionOfShippingMethod.length === 0;
            }

          },
          (err:RestResponse)=> {

            this.isFormReady = true;
            this.shippingError = true;

      });
    }
  }

  onClose() {
    this._dialogRef.close();
  }

  onSubmit() {
    if(this.shippingError) {
      this._dialogRef.close();
    }
    else
    {

      const shippingMethodSelected = this._shippingMethodComponent.getShippingFormData();
      if (shippingMethodSelected.shipperHqService) {
        const shipperHqServiceModel: ShipperHqServicesModel = new ShipperHqServicesModel().deserialize(shippingMethodSelected.shipperHqService);
        let valueReturn = {
          integrationName: null,
          shippingCompanyIntegrationId: null,
          shippingServiceId: null,
          shippingCarrierId: null,
          shippingMethodName: null,
        }
        valueReturn.shippingCompanyIntegrationId = shipperHqServiceModel.companyIntegrationId
        valueReturn.shippingServiceId = shipperHqServiceModel.serviceId
        valueReturn.shippingCarrierId = shipperHqServiceModel.carrierCode
        valueReturn.shippingMethodName = shipperHqServiceModel.serviceName
        valueReturn.integrationName = shipperHqServiceModel.integrationName
        this._dialogRef.close({ newShippingMethod: valueReturn });
        return;
      }

      if (!shippingMethodSelected ||
          !shippingMethodSelected.shippingService) {
        this._meta.showNotificationCustomMessage(responseCode.errorBadRequestCode, KeyName.form_invalid);
        return;
      }

      const attrShippingService: ShippingRatesModel = new ShippingRatesModel().deserialize(shippingMethodSelected.shippingService);

      if (attrShippingService.serviceId === 'FIXED_SHIPPING_RATE') {
        let valueReturn = {
          shippingServiceId: null,
          shippingCarrierId: null,
          shippingMethodName: null,
          shippingCompanyIntegrationId: null,
          fixedShippingRate: null,
        }
        valueReturn.shippingServiceId = attrShippingService.serviceId?.toString();
        valueReturn.shippingCarrierId = attrShippingService.carrierName
        valueReturn.shippingMethodName = attrShippingService.serviceName
        valueReturn.fixedShippingRate = shippingMethodSelected.shippingAmount
        if (!shippingMethodSelected.shippingAmount) {
          return;
        }
        this._dialogRef.close({ newShippingMethod: valueReturn });
        return;
      }

      let valueReturn = {
        integrationName: null,
        shippingServiceId: null,
        shippingAmount: null,
        shippingCompanyIntegrationId: null
      }


      if (attrShippingService?.integrationName == ShippingCustomFreeShippingStaticValues.shippingCustomKey || attrShippingService?.integrationName == ShippingCustomFreeShippingStaticValues.shippingFreeKey
        ) {
        valueReturn.shippingAmount = shippingMethodSelected.shippingAmount;
        valueReturn.shippingServiceId = null;
        valueReturn.shippingCompanyIntegrationId = null;
      } else {
        valueReturn.shippingAmount = shippingMethodSelected.shippingService.amount;
        valueReturn.shippingServiceId = shippingMethodSelected.shippingService.serviceId?.toString();
        valueReturn.shippingCompanyIntegrationId = shippingMethodSelected.shippingService.companyIntegrationId;
      }

      this._dialogRef.close({ newShippingMethod: valueReturn });
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
